import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  className = '',
  icon: Icon 
}) => {
  const baseStyles = 'px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-all';
  
  const variants = {
    primary: 'bg-[#33564B] text-white hover:opacity-90',
    secondary: 'bg-white text-[#33564B] border border-[#E0E0E0] hover:bg-gray-50',
    outline: 'bg-transparent text-[#33564B] underline hover:opacity-70'
  };

  return (
    <button 
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
};

export default Button;

